import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Modal from 'app/modal/v3';
import WebcamRecordVideo from 'chats/RecordVideo';
import VideoPreview from 'chats/VideoPreview';

// Record a video from the webcam, mirroring src/chats/record-chat-button.js:
// WebcamRecordVideo → VideoPreview (Reshoot / Upload). onAccept returns a File.
const RecordVideoModal = ({ onClose, onAccept }) => {
  const [file, setFile] = useState(null);
  const [videoTime, setVideoTime] = useState(null);

  return (
    <Modal
      close={{ onClose }}
      maxWidth={800}
      title="Record Your Video"
      closeOnOutsideClick={false}
      shadeProps={{ pt: [0, 4] }}
    >
      {file ? (
        <VideoPreview
          videoTime={videoTime}
          blob={file}
          onReject={() => setFile(undefined)}
          onAccept={() => {
            const newFile = new File([file], file.name, { type: file.type, lastModified: Date.now() });
            onAccept(newFile);
          }}
          minHeight={360}
          height="auto"
          m="auto"
          width={['100vw', '640px', '800px']}
        />
      ) : (
        <WebcamRecordVideo setVideoTime={setVideoTime} onEnded={(blob) => setFile(blob)} />
      )}
    </Modal>
  );
};

RecordVideoModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
};

export default RecordVideoModal;
